export default __webpack_public_path__ + "static/media/Getac.ef1c0fd1.png";